module.exports = __webpack_public_path__ + "img/frame (253).6e19bdb1.jpg";